export * from './button-theme-a.component';
export * from './button-theme-a.module';
